import { removeURLParameter } from "../util";

export default {
  data() {
    return {
      ajaxLoading: false,
      data: {},
    };
  },
  mounted() {
    window.addEventListener("popstate", this._shopifyAjax_handlePopState);
    history.replaceState({ _shopifyAjax: location.href }, location.href);
  },
  methods: {
    async ajaxLoad(url, withState = true) {
      const cleanUrl = removeURLParameter(url, "view");
      this.ajaxLoading = true;
      try {
        const { data } = await this.$http(cleanUrl, {
          params: {
            view: "ajax",
          },
        });
        if (withState) {
          history.pushState({ _shopifyAjax: cleanUrl }, "", cleanUrl);
        }
        this.data = data;
      } finally {
        this.ajaxLoading = false;
      }
    },
    _shopifyAjax_handlePopState() {
      if (history.state && history.state._shopifyAjax) {
        this.ajaxLoad(history.state._shopifyAjax, false);
      }
    },
  },
};
